/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { army_list } from '../models/army_list';
import type { army_list_dto } from '../models/army_list_dto';
import type { army_list_full } from '../models/army_list_full';
import type { army_list_last_update } from '../models/army_list_last_update';
import type { army_list_txt_dto } from '../models/army_list_txt_dto';
import type { army_list_txt_formated } from '../models/army_list_txt_formated';
import type { army_list_unit } from '../models/army_list_unit';
import type { army_list_unit_dto } from '../models/army_list_unit_dto';
import type { contest } from '../models/contest';
import type { folder } from '../models/folder';
import type { folder_all } from '../models/folder_all';
import type { folder_dto } from '../models/folder_dto';
import type { warhall_match_dto } from '../models/warhall_match_dto';
import type { warhall_match_formated } from '../models/warhall_match_formated';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BuilderService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Create the army list unit
   * @returns army_list_unit successful
   * @throws ApiError
   */
  public createArmyListUnit({
    locale,
    id,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army list identifier
     */
    id: string;
    requestBody?: army_list_unit_dto;
  }): CancelablePromise<army_list_unit> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/builder/army_lists/{id}/army_list_units',
      path: {
        locale: locale,
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Update the army list unit
   * @returns army_list_unit successful
   * @throws ApiError
   */
  public updateArmyListUnit({
    locale,
    armyListUnitId,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army list unit identifier
     */
    armyListUnitId: string;
    requestBody?: army_list_unit_dto;
  }): CancelablePromise<army_list_unit> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/{locale}/api/v1/builder/army_list_units/{army_list_unit_id}',
      path: {
        locale: locale,
        army_list_unit_id: armyListUnitId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete the army list unit
   * @returns void
   * @throws ApiError
   */
  public deleteArmyListUnit({
    locale,
    armyListUnitId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army list unit identifier
     */
    armyListUnitId: string;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/{locale}/api/v1/builder/army_list_units/{army_list_unit_id}',
      path: {
        locale: locale,
        army_list_unit_id: armyListUnitId,
      },
    });
  }
  /**
   * Get the army list unit
   * @returns army_list_unit successful
   * @throws ApiError
   */
  public getArmyListUnit({
    locale,
    armyListUnitId,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Army list unit identifier
     */
    armyListUnitId: string;
  }): CancelablePromise<army_list_unit> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/builder/army_list_units/{army_list_unit_id}',
      path: {
        locale: locale,
        army_list_unit_id: armyListUnitId,
      },
    });
  }
  /**
   * Create the army list
   * @returns army_list successful
   * @throws ApiError
   */
  public createArmyList({
    locale,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    requestBody?: army_list_dto;
  }): CancelablePromise<army_list> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/builder/army_lists',
      path: {
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get army lists
   * @returns army_list_full successful
   * @throws ApiError
   */
  public getArmyLists({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<army_list_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/builder/army_lists/full',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get army lists with updated_at
   * @returns army_list_last_update successful
   * @throws ApiError
   */
  public getUpdatedAtArmyLists({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<army_list_last_update>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/builder/army_lists/last_update',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Update the army list
   * @returns army_list successful
   * @throws ApiError
   */
  public updateArmyList({
    id,
    locale,
    requestBody,
  }: {
    /**
     * Army list identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
    requestBody?: army_list_dto;
  }): CancelablePromise<army_list> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/{locale}/api/v1/builder/army_lists/{id}',
      path: {
        id: id,
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete the army list
   * @returns void
   * @throws ApiError
   */
  public deleteArmyList({
    id,
    locale,
  }: {
    /**
     * Army list identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/{locale}/api/v1/builder/army_lists/{id}',
      path: {
        id: id,
        locale: locale,
      },
    });
  }
  /**
   * Get the army list
   * @returns army_list successful
   * @throws ApiError
   */
  public getArmyList({
    id,
    locale,
  }: {
    /**
     * Army list identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<army_list> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/builder/army_lists/{id}',
      path: {
        id: id,
        locale: locale,
      },
    });
  }
  /**
   * Get folders
   * @returns folder_all successful
   * @throws ApiError
   */
  public getFolders({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<folder_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/builder/folders',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Create the folder
   * @returns folder successful
   * @throws ApiError
   */
  public createFolder({
    locale,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    requestBody?: folder_dto;
  }): CancelablePromise<folder> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/builder/folders',
      path: {
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Get folders
   * @returns folder_all successful
   * @throws ApiError
   */
  public getAllFolders({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<folder_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/builder/folders/all',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Get folders
   * @returns folder successful
   * @throws ApiError
   */
  public getFullFolders({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<folder>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/builder/folders/full',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Update the folder
   * @returns folder successful
   * @throws ApiError
   */
  public updateFolder({
    id,
    locale,
    requestBody,
  }: {
    /**
     * folder identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
    requestBody?: folder_dto;
  }): CancelablePromise<folder> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/{locale}/api/v1/builder/folders/{id}',
      path: {
        id: id,
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete the folder
   * @returns void
   * @throws ApiError
   */
  public deleteFolder({
    id,
    locale,
  }: {
    /**
     * folder identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/{locale}/api/v1/builder/folders/{id}',
      path: {
        id: id,
        locale: locale,
      },
    });
  }
  /**
   * Get the folder
   * @returns folder successful
   * @throws ApiError
   */
  public getFolder({
    id,
    locale,
  }: {
    /**
     * folder identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<folder> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/builder/folders/{id}',
      path: {
        id: id,
        locale: locale,
      },
    });
  }
  /**
   * Convert a folder to a contest
   * @returns contest successful
   * @throws ApiError
   */
  public folderToEvent({
    id,
    locale,
  }: {
    /**
     * folder identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<contest> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/builder/folders/{id}/to-event',
      path: {
        id: id,
        locale: locale,
      },
    });
  }
  /**
   * Add an army list into folder
   * @returns void
   * @throws ApiError
   */
  public folderAddArmyList({
    id,
    armyListId,
    locale,
  }: {
    /**
     * Folder identifier
     */
    id: string;
    /**
     * Army list identifier
     */
    armyListId: string;
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/builder/folders/{id}/add/{army_list_id}',
      path: {
        id: id,
        army_list_id: armyListId,
        locale: locale,
      },
    });
  }
  /**
   * Format an text army list
   * @returns army_list_txt_formated successful
   * @throws ApiError
   */
  public formatArmyListText({
    locale,
    date,
    game,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    /**
     * Creation date of the list in Unix Epoch format
     */
    date?: number;
    /**
     * Can be ninthAge | battle | essenceOfWar | theOldWorld by default ninthAge
     */
    game?: string;
    requestBody?: army_list_txt_dto;
  }): CancelablePromise<army_list_txt_formated> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/builder/imports/format',
      path: {
        locale: locale,
      },
      query: {
        date: date,
        game: game,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `bad request`,
      },
    });
  }
  /**
   * Format an text army list
   * @returns warhall_match_formated successful
   * @throws ApiError
   */
  public formatWarhallMatch({
    locale,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    requestBody?: Array<warhall_match_dto>;
  }): CancelablePromise<Array<warhall_match_formated>> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/builder/imports/warhall/matches/format',
      path: {
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Search army lists
   * @returns army_list_full successful
   * @throws ApiError
   */
  public searchArmyList({
    locale,
    armyId,
    min,
    max,
  }: {
    /**
     * Current locale
     */
    locale: string;
    armyId?: number;
    min?: number;
    max?: number;
  }): CancelablePromise<Array<army_list_full>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/builder/searchs',
      path: {
        locale: locale,
      },
      query: {
        army_id: armyId,
        min: min,
        max: max,
      },
    });
  }
}
